import { SEO } from "utils/helmet/components/SEO";
import url from "url/index";
import HomePage from "components/pages/Casino/Home";

const HomePageContainer = () => {
  return (
    <>
      <SEO pathname={url.routes.casino.index()} />
      <HomePage />
    </>
  );
};

export default HomePageContainer;
